module.exports = __webpack_public_path__ + "media/components/country-flag/static/cd-10376086d57b575f986f4755be4c78ce.svg";